<template>
    <!--系统首页_旧首页备份_20210127-->
    <div class="index">
        <el-container>
            <el-aside style="width: 260px">
                <ul class="left_url_tab">
                    <li class="li-title_1">全部订单</li>
                    <li class="li-title_2" @click="title2Click($event,'/all')">全部订单</li>
                    <li class="li-title_1">订单</li>
                    <li class="li-title_2" @click="title2Click($event,'/pending')">待处理</li>
                    <li class="li-title_2 title-2-select" @click="title2Click($event,'/djy')">待交运</li>
                    <li class="li-title_2" @click="title2Click($event,'/printOrder')">待打单</li>
                    <li class="li-title_2" @click="title2Click($event,'/waitDelivery')">待发货</li>
                    <li class="li-title_2" @click="title2Click($event,'/delivery')">已发货</li>
                    <li class="li-title_1">其他</li>
                    <li class="li-title_2" @click="title2Click($event,'/refund')">已退款</li>
                    <li class="li-title_2" @click="title2Click($event,'/shelve')">已搁置</li>
                    <li class="li-title_1">手动订单</li>
                    <li class="li-title_2" @click="title2Click($event,'/createOrder')">创建手工订单</li>
                </ul>
                <ul class="left_url_tab">
                    <li class="li-title_1">采购订单</li>
                    <li class="li-title_2">
                        <router-link to="/grxx" class="r_link">全部订单</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">创建采购单</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">待审核</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">待收货</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">已完成</router-link>
                    </li>

                    <li class="li-title_1">供货管理</li>
                    <li class="li-title_2">
                        <router-link to="/rolemg" class="r_link">供货商</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/cymg" class="r_link">收货地址</router-link>
                    </li>
                </ul>

                <ul class="left_url_tab">
                    <li class="li-title_1">商品管理</li>
                    <li class="li-title_2">
                        <router-link to="/grxx" class="r_link">商品管理</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">仓库清单</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">商品配对</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">仓库设置</router-link>
                    </li>
                </ul>


                <ul class="left_url_tab">
                    <li class="li-title_1">帐号管理</li>
                    <li class="li-title_2">
                        <router-link to="/grxx" class="r_link">个人信息</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/wdtg" class="r_link">我的推广</router-link>
                    </li>
                    <li class="li-title_1">权限管理</li>
                    <li class="li-title_2">
                        <router-link to="/rolemg" class="r_link">角色管理</router-link>
                    </li>
                    <li class="li-title_2">
                        <router-link to="/cymg" class="r_link">成员管理</router-link>
                    </li>
                    <li class="li-title_1">平台授权</li>
                    <li class="li-title_2">
                        <router-link to="/ptsq" class="r_link">平台授权</router-link>
                    </li>
                </ul>

            </el-aside>
            <el-main class="el-main1">
              <div style="width: 100%;height: 100%">
                  <div style="width: 20%;height: 100%;position: absolute;left: 21.5%;float: left">
                       <div style="width: 100%;height: 30%;background-color: white">
                           <div style="width: 100%;height: 22.5%;align-items: center;padding-left: 20px;display: flex;">
                               <span style="font-size: 16px;font-weight: 700;color:#666666 ;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal;
                                 text-rendering: optimizeLegibility;font-kerning: normal ">客户服务</span>
                           </div>
                           <div style="border-top: 0.5px solid  rgba(245, 245, 245, 1);padding-top: 10px;padding-left: 30px">
                               <span style="font-size: 14px;color:#afafaf ">客户邮件：</span>
                               <span style="font-size: 14px;">server@qq.com</span><br><br>
                               <span style="font-size: 14px;color:#afafaf ">客户QQ群：</span>
                               <span style="font-size: 14px;">XXXXXX</span><br><br>
                               <span style="font-size: 14px;color:#afafaf ">客服微信：</span>
                               <span style="font-size: 14px;">XXXXXXX</span>
                           </div>

                       </div>
                      <div style="width: 100%;height: 12%;align-items: center;display: flex;background-color: white;position: absolute;top:31.5%;">
                          <span style="font-size: 16px;color:#666666;font-weight: 700;padding-left: 20px;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">推荐有礼：</span>
                          <span style="padding-left: 5px;padding-right: 5px"><img src="../assets/images/1.jpg" style="width: 40px;height: 40px"></span>
                          <span style="font-size: 16px;color:#afafaf;font-weight: 700 ">分享好友</span>
                      </div>

                      <div style="width: 100%;height: 50%;background-color: white;position: absolute;top: 46%;">
                          <div style="width: 100%;height: 17.5%;align-items: center;padding-left: 20px;display: flex;">
                              <span style="font-size: 16px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal ">常见问题</span>
                          </div>
                          <div style="border-top: 0.5px solid  rgba(245, 245, 245, 1);padding-top: 30px;padding-left: 35px">
                                <span style="font-size: 14px;color: #2e9ad0"><a
                                        href="https://www.wulihub.com.cn/gc/WZkk63/%E6%9F%A5%E7%9C%8B%E8%AF%A6%E6%83%85.html"
                                        style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">数据采集插件安装使用方法</a></span><br><br>
                              <span style="font-size: 14px;color: #2e9ad0"><a href="#" style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">产品刊登操作方法</a></span>
                          </div>
                      </div>
                  </div>
                  <!--主体-->
                  <div style="height: 100%;width: 54.41%;position: absolute;left: 44%">
                      <div style="width: 100%;height: 41.5%;background-color: white">
                          <div style="width: 97.3%;height: 16%;align-items: center;padding-left: 20px;display: flex;">
                              <span style="font-size: 16px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal;">待办事项</span>
                          </div>
                          <div style="border-top: 0.5px solid  rgba(245, 245, 245, 1); width: 100%;height: 78%;">
                              <table>
                                  <tr>
                                      <td style="width: 10%;    position: absolute;left: 4%;top: 13%; ">
                                          <span style="font-size: 15px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal ">订单</span>
                                      </td>
                                      <td style="margin: 0px;padding-right: 0px;width: 0.9%;position:absolute;top: 9%;left: 11.7%">
                                          <div style="background-color: #ff4040;height: 70px">

                                          </div>

                                      </td>
                                      <td style="margin: 0px;padding-left: 0px;padding-right: 28px;position: absolute;top:9%;left: 12.8% ;">
                                          <div style="background-color: rgba(245, 245, 245, 1);height: 70px;width: 125px;text-align: center;line-height: 35px">
                                              <span style="font-size: 14px;color: #666666;font-family: '微软雅黑', sans-serif ;">剩余发货天数<1天</span><br>
                                              <span style="font-size: 20px;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;" ><a href="#" @click='onQbdd' >3</a></span>
                                          </div>
                                      </td>

                                      <td style="margin: 0px;padding-right: 0px;width: 0.9%;position:absolute;top: 9%;left: 34.3%">
                                          <div style="background-color: #0060a0;height: 70px">

                                          </div>

                                      </td>
                                      <td style="margin: 0px;padding-left: 0px;padding-right: 28px;position: absolute;top:9%;left:35.3%;">
                                          <div style="background-color: rgba(245, 245, 245, 1);height: 70px;width: 125px;text-align: center;line-height: 35px">
                                              <span style="font-size: 14px;color: #666666;font-family: '微软雅黑', sans-serif ;">待处理</span><br>
                                              <span style="font-size: 20px;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;"><a href="#" @click='onDcl'>3</a></span>
                                          </div>
                                      </td>


                                      <td style="margin: 0px;padding-right: 0px;width: 0.9%;position:absolute;top:9%;left: 57%">
                                          <div style="background-color: #ff9933;height: 70px">

                                          </div>

                                      </td>


                                      <td style="margin: 0px;padding-left: 0px;padding-right: 28px;position: absolute;top:9%;left: 57.9% ;">
                                          <div style="background-color: rgba(245, 245, 245, 1);height: 70px;width: 125px;text-align: center;line-height: 35px">
                                              <span style="font-size: 14px;color: #666666;font-family: '微软雅黑', sans-serif ;">待交运</span><br>
                                              <span style="font-size: 20px;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;"><a href="#" @click='onDjy'>3</a></span>
                                          </div>
                                      </td>


                                      <td style="margin: 0px;padding-right: 0px;width: 0.9%;position:absolute;top: 9%;left: 78.9%">
                                          <div style="background-color: #20ff80;height: 70px">

                                          </div>

                                      </td>


                                      <td style="margin: 0px;padding-left: 0px;padding-right: 28px;position: absolute;top: 9%;left:79.9% ;">
                                          <div style="background-color: rgba(245, 245, 245, 1);height: 70px;width: 125px;text-align: center;line-height: 35px">
                                              <span style="font-size: 14px;color: #666666;font-family: '微软雅黑', sans-serif ;">待发货</span><br>
                                              <span style="font-size: 20px;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;"><a href="#"  @click='onDfh'>3</a></span>
                                          </div>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td style="width: 40px;    position: absolute;left: 4%;top: 27%; ">
                                          <span style="font-size: 15px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal ">采购</span>
                                      </td>
                                      <td style="margin: 0px;padding-right: 0px;width: 0.9%;position:absolute;top: 24%;left: 11.7%">
                                          <div style="background-color: #ff4040;height: 70px">

                                          </div>

                                      </td>
                                      <td style="margin: 0px;padding-left: 0px;padding-right: 28px;position: absolute;top:24%;left: 12.8% ;">
                                          <div style="background-color: rgba(245, 245, 245, 1);height: 70px;width: 125px;text-align: center;line-height: 35px">
                                              <span style="font-size: 14px;color: #666666;font-family: '微软雅黑', sans-serif ;">待审核</span><br>
                                              <span style="font-size: 20px;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;"><a href="#" @click='onDsh'>3</a></span>
                                          </div>
                                      </td>

                                      <td style="margin: 0px;padding-right: 0px;width: 0.9%;position:absolute;top: 24%;left: 34.3%">
                                          <div style="background-color: #0060a0;height: 70px">

                                          </div>

                                      </td>
                                      <td style="margin: 0px;padding-left: 0px;padding-right: 28px;position: absolute;top:24%;left:35.3%;">
                                          <div style="background-color: rgba(245, 245, 245, 1);height: 70px;width: 125px;text-align: center;line-height: 35px">
                                              <span style="font-size: 14px;color: #666666;font-family: '微软雅黑', sans-serif ;">待到货</span><br>
                                              <span style="font-size: 20px;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;"><a href="#" @click='onDdh'>3</a></span>
                                          </div>
                                      </td>

                                  </tr>
                              </table>

                          </div>




                      </div>

                      <div style="width: 60%;height: 50.3%;background-color: white;float: left;position: absolute;top: 46%;">

                          <div style="width: 100%;height: 17.5%;align-items: center;padding-left: 20px;display: flex;">
                              <span style="font-size: 16px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal ">公告</span>
                          </div>
                          <div style="border-top: 0.5px solid  rgba(245, 245, 245, 1);padding-top: 30px;padding-left: 35px">
                                <span style="font-size: 14px;color: #2e9ad0"><a
                                        href="https://www.wulihub.com.cn/gc/WZkk63/%E5%85%AC%E5%91%8A%E8%AF%A6%E6%83%85.html"
                                        style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">本周新增功能汇总</a></span>
                              <span style="float: right;font-size: 14px;color:#afafaf">2020-7-27 15:43:29</span>
                              <br><br>
                              <span style="font-size: 14px;color: #2e9ad0"><a href=""
                                                                              style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">新功能</a></span>
                              <span style="float: right;font-size: 14px;color:#afafaf">2020-7-27 15:43:29</span><br><br><br>
                              <span style="float: right;"><img src="../assets/images/1.jpg" style="width: 40px;height: 40px"></span>
                          </div>

                      </div>
                      <div style="width:37%;height: 50.3%;background-color: white;position: absolute;top: 46%;left: 63% ">
                          <div style="width: 92%;height: 17.5%;align-items: center;padding-left: 20px;display: flex;">
                              <span style="font-size: 16px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal ">常见菜单</span>
                          </div>
                          <div style="border-top: 0.5px solid  rgba(245, 245, 245, 1);padding-top: 30px;padding-left: 35px">
                                <span style="font-size: 14px;color: #2e9ad0"><a href="#"
                                                                                style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">平台授权</a></span><br><br>
                              <span style="font-size: 14px;color: #2e9ad0"><a href="#"
                                                                              style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">数据采集</a></span><br><br>
                              <span style="font-size: 14px;color: #2e9ad0"><a href="#"
                                                                              style="text-decoration:none;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal">创建产品</a></span>
                          </div>
                      </div>
                  </div>
                  <div style="width: 77%;height: 100%;background-color: white;position: absolute;top: 112%;left: 21.5%">
                      <div style="width:  60%;height: 10%;align-items: center;padding-left: 20px;display: flex;margin: 0px;float: left">
                          <span style="font-size: 16px;font-weight: 700;color:#666666;font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;font-style: normal ">销售业绩</span>
                      </div>
                      <div style="width:  38%;height: 10%;align-items: center;padding-left: 20px;display: flex;float: left;margin: 0px;padding: 0px">
                          <tr>
                              <td style="width: 70px;font-size: 14px;font-weight: 700;color:#afafaf;">本日</td>
                              <td style="width: 70px;font-size: 14px;font-weight: 700;color:#afafaf;">本周</td>
                              <td style="width: 70px;font-size: 14px;font-weight: 700;color:#afafaf;">本月</td>
                              <td style="width: 270px;">
                                  <div class="block">
                                      <el-date-picker
                                              v-model="value1"
                                              type="date"
                                              placeholder="选择日期">
                                      </el-date-picker>
                                  </div>

                              </td>
                          </tr>
                      </div>

                      <div style="width:  100%;height: 10%;align-items: center;padding-left: 20px;display: flex;float: left;margin: 0px;">
                          <div style="height: 40px;width: 30%;margin: 0px;padding: 0px;float: left">
                              <el-radio-group v-model="radio1" style="height: 40px">
                                  <el-radio-button label="上海"></el-radio-button>
                                  <el-radio-button label="北京"></el-radio-button>
                                  <el-radio-button label="广州"></el-radio-button>
                                  <el-radio-button label="深圳"></el-radio-button>
                              </el-radio-group>
                          </div>
                          <div style="height: 40px;width: 10%;margin: 0px;padding: 0px;float: left">
                              <el-select clearable  v-model="temp"  placeholder="默认按订单金额">
                                  <el-option label="按订单金额" value="shanghai"></el-option>
                                  <el-option label="按订单数量" value="beijing"></el-option>
                              </el-select>
                          </div>
                      </div>
                      <div style="width:  100%;height: 60%;align-items: center;display: flex;float: left;" id="myChart">
                      </div>
                  </div>
              </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: 'index',
        components: {},
        data() {
            return {
                value1:null,
                radio1:null,
                temp:'shanghai'

            }
        },
        mounted() {
            this.xsqk();
            $.ajax({
                url:process.env.BASE_URL + 'exportTemplate.json',
                method:'get',
                success:function (res) {
                    sessionStorage.setItem("baseTemplate",JSON.stringify(res.baseTemplate));
                }
            })
        },
        methods: {
            xsqk() {
                let myChart = this.$echarts.init(document.getElementById('myChart'))
                myChart.setOption({

                    legend: {},
                    tooltip: {},
                    dataset: {
                        dimensions: ['product', '付款金额', '订单总金额', '退货金额'],
                        source: [
                            {product: '20190201', '付款金额': 43.3, '订单总金额': 85.8, '退货金额': 93.7},
                            {product: '20190202', '付款金额': 83.1, '订单总金额': 73.4, '退货金额': 55.1},
                            {product: '20190203', '付款金额': 86.4, '订单总金额': 65.2, '退货金额': 82.5},
                            {product: '20190204', '付款金额': 72.4, '订单总金额': 53.9, '退货金额': 39.1},
                            {product: '20190205', '付款金额': 72.4, '订单总金额': 53.9, '退货金额': 39.1},
                            {product: '20190206', '付款金额': 72.4, '订单总金额': 53.9, '退货金额': 39.1},
                            {product: '20190207', '付款金额': 72.4, '订单总金额': 53.9, '退货金额': 39.1}
                        ]
                    },
                    xAxis: {type: 'category'},
                    yAxis: {},
                    // Declare several bar series, each will be mapped
                    // to a column of dataset.source by default.
                    series: [
                        {type: 'bar', color: '#0080FF',},
                        {type: 'bar', color: '#02DF82'},
                        {type: 'bar', color: '#FFDC35'}
                    ]
                })
            },
            title2Click(e,url){
                var _dom = document.querySelector('.li-title_2.title-2-select');
                if (_dom) {
                    _dom.classList.toggle('title-2-select');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
                }
                e.target.classList.toggle('title-2-select');
                this.$router.push(url);
            },
            onQbdd() {
                //直接跳转
                this.$router.replace('/order')
            },
            onDcl() {
                //直接跳转
                this.$router.replace('/djy')
            },
            onDjy() {
                //直接跳转
                this.$router.replace('/djy')
            },
            onDfh() {
                //直接跳转
                this.$router.replace('/djy')
            },
            onDsh() {
                //直接跳转
                this.$router.replace('/dsh')
            },
            onDdh() {
                //直接跳转
                this.$router.replace('/ddh')
            }
        }
    }
</script>

<style scoped>
    @import '../assets/css/order.css';
    .order_index{
        width: 100%;
    }
    .index {
        height: 100%;
        width: 100%;
    }

    .el-container {
        height: 100%;
    }

    .el-aside {
        /*background-color: blue;*/
    }

    .el-main1 {
        background-color: rgba(245, 245, 245, 1);
        padding: 0px;
        min-width: 1500px;
    }

    .left_url_tab{
        border: 1px solid #c7c7c7;
        font-size: 13px;
        font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    }
    

    .li-title_1{
        height: 32px;
        line-height: 32px;
        background-color: #c1c1c154;
        vertical-align: top;
        padding-left: 5px;
        font-weight: 600;
    }
    .li-title_2{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 20px;
    }
    .li-title_3{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 40px;
    }
    .li-title_2:hover,.li-title_3:hover{
        background-color: #409eff;
        color: white;
        cursor: pointer;
    }
    .li-help{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        text-align: center;
        font-size: 16px;
    }
    .li-help a{
        text-decoration: none;
        color: #409eff;
    }



    /*.left_url_tab{*/
        /*border: 1px solid #c7c7c7;*/
        /*padding: 0 !important;*/
        /*margin: 0 !important;*/
        /*font-size: 13px;*/
        /*font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;*/
    /*}*/
    /*.left_url_tab li:not(:last-child){*/
        /*list-style: none;*/
        /*border-bottom: 1px solid #EBEEF5;*/
    /*}*/

    /*.li-title_1{*/
        /*height: 32px;*/
        /*line-height: 32px;*/
        /*background-color: #c1c1c154;*/
        /*vertical-align: top;*/
        /*padding-left: 5px;*/
        /*font-weight: 600;*/
        /*font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;*/
    /*}*/
    /*.li-title_2{*/
        /*height: 28px;*/
        /*line-height: 28px;*/
        /*vertical-align: top;*/
        /*padding-left: 20px;*/
        /*font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;*/
    /*}*/
    /*.li-title_3{*/
        /*height: 28px;*/
        /*line-height: 28px;*/
        /*vertical-align: top;*/
        /*padding-left: 40px;*/
        /*font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;*/
    /*}*/
    /*.li-title_2:hover,.li-title_3:hover{*/
        /*background-color: #409eff;*/
        /*color: white;*/
        /*cursor: pointer;*/
    /*}*/
    /*.li-help{*/
        /*height: 28px;*/
        /*line-height: 28px;*/
        /*vertical-align: top;*/
        /*text-align: center;*/
        /*font-size: 16px;*/
    /*}*/
    /*.li-help a {*/
        /*text-decoration: none;*/
    /*}*/

</style>
